export const environment = {
  production: false,
  url: 'https://stagingapi.dcf-tt.com'
  // url: 'http://localhost:8090'
}

